import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'utils/components/tooltip';
import Droplist from 'utils/components/droplist';
import Icon from 'utils/components/icon';
import { CUSTOM } from '../analytics/models/period';

class CustomSelector extends Component {
  handleMoreClick() {
    this.refs.menuItem.toggle();
  }
  hide() {
    this.refs.menuItem.hide();
  }
  render() {
    var { items, selected, width, hideOnClick, customSelected } = this.props;
    if (selected === CUSTOM) {
      selected = customSelected;
    } else {
      selected = items.filter(item => item.value === selected);
      if (selected.length > 0) {
        selected = selected[0].element;
      }
    }
    var style = { width };

    return (
      <div className="custom-selector" ref="menuLabel" onClick={this.handleMoreClick.bind(this)}>
        <div className="selector-button" style={style}>
          {selected}
          <Icon name="arrow" className="arrow-icon" />
        </div>
        <Tooltip
          className="dropdown tooltip-general"
          hideOnClick={hideOnClick}
          hasScreenBoundries
          caret
          ref="menuItem"
          alignElement={() => this.refs.menuLabel}
        >
          <Droplist items={items.map(item => item.element)} />
        </Tooltip>
      </div>
    );
  }
}
CustomSelector.displayName = 'CustomSelector';

CustomSelector.defaultProps = {
  hideOnClick: true
};

CustomSelector.propTypes = {
  items: PropTypes.array.isRequired,
  selected: PropTypes.string,
  hideOnClick: PropTypes.bool,
  width: PropTypes.number
};

export default CustomSelector;
